import React, { Component } from 'react';
// import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import Loadable from "react-loadable";
import { withRouter } from "react-router";
import Index from './components';
import { confirmAlert } from "react-confirm-alert";
import App from './components/App';
// import { BrowserRouter, Router  } from "react-router-dom";
// import { ConnectedRouter } from 'connected-react-router'
// import { configureStore, history } from './store/configureStore';
// import Privacy from './components/marketing/privacy';
import Dashboard from "./components/Index/dashboard";
// import MySetting from "./components/setting/mysetting";
import { PatientPrivateRoute, SpecialistPrivateRoute, AdminPrivateRoute } from "./components/common/AuthHOC";
import SpecialistDashboard from './components/Index/specialistDashboard';
import AdminIndex from './components/admin/Index/adminIndex';
import ErrorPage from './components/common/404';
import SpecialistRequirements from './components/specialist/SpecialistRequirements';
import adminAuth from './components/admin/auth/adminAuth';
import GapiIndex from './components/calendar/GapiIndex';
import OutlookIndex from './components/calendar/OutlookIndex';
import disputeAppointment from './components/appointment/dispute/disputeAppointment';
import disputeHelp from './components/appointment/dispute/disputeHelp';
import disputeSearch from './components/appointment/dispute/disputeSearch';
import disputeList from './components/appointment/dispute/disputeList';
import disputeLogin from './components/appointment/dispute/disputeLogin';
import ScrollToTop from './tools/scrollToTop'
import openSocket from "socket.io-client";
import * as url from "./tools/config";
import { ToastContainer, toast } from "react-toastify";

const socket = openSocket(url.getURLForServer(process.env.REACT_APP_NODE_ENV).SOCKET_URL);

const AsyncMarketingDashboard = Loadable({
	loader: () => import('./components/Index/marketingDashboard'),
	loading: "Loading",
});
const AppsUnderDevlopment = Loadable({
	loader: () => import('./components/marketing/appsUnderDevelopement'),
	loading: "Loading",
});
const AsyncTerms = Loadable({
	loader: () => import('./components/marketing/terms'),
	loading: "Loading",
});
const AsyncBlogsFrontEnd = Loadable({
	loader: () => import('./components/marketing/blog'),
	loading: "Loading",
});
const AsyncHowItWorks = Loadable({
	loader: () => import('./components/marketing/howitworks'),
	loading: "Loading",
});
const AsyncAboutUs = Loadable({
	loader: () => import('./components/marketing/aboutus'),
	loading: "Loading",
});
function isPatient(nextState, replace, callback) {
	var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
	if (user != null && user.type == "patient") {
		isPatientAuthorized(nextState, replace, callback);
		// toastr.error('Token either invalid or expired!')
		// replace('/')
		return callback();
	} else {
		replace("/");
		return callback();
	}
}
function isPatientAuthorized(nextState, replace, callback) {
	const token = localStorage.getItem("token");
	var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
	if (!token) {
		replace("/");
		return callback();
	} else {
		return callback();
	}
}


export default class Routes extends Component {

	constructor(props) {
		super(props)
	}

	socketFunction = (data) => {
		console.log("socket is initialiizes", data)
		socket.on("notify_client", (messageData) => {
			console.log("propsss", data)
			console.log("notify_client", messageData)

			let url =
				messageData.videoData.userType == "patient"
					? "/specialist/waiting-room-receiver/" +
					messageData.videoData.videoId +
					"/" +
					messageData.videoData.appointmentId
					: "/dashboard/waiting-room-receiver/" +
					messageData.videoData.videoId +
					"/" +
					messageData.videoData.appointmentId;

			let videoDataObj = messageData.videoData;
			confirmAlert({
				title: "Confirm",
				message: messageData.videoData.userType == 'specialist' ?
					"Incoming Video Call  Dr. " +
					messageData.videoData.userName + " wishes to consult you." :
					"Incoming Video Call from " +
					messageData.videoData.userName + "",
				buttons: [
					{
						label: "Accept",
						onClick: () => {
							localStorage.setItem('videoDataObj', JSON.stringify(messageData.videoData))
							data.history.push(url);
						}
					},
					{
						label: "Decline",
						onClick: () => {
							socket.emit(
								"notrecieved",
								{
									videoData: videoDataObj,
									notificationType: "VIDEO_CALL_NOTRECIEVED"
								},
								function () {
									alert("here");
								}
							);
						}
					}
				]
			});
		});
		socket.on("notify_receive", function (messageData) {
		console.log("notifiy receiee", data)
					
			let title =
				messageData.videoData.userType == "patient"
					? "specialist"
					: "patient";
			let url =
				messageData.videoData.userType == "patient"
					? "/specialist/video-call-connect/" +
					messageData.videoData.videoId
					: "/dashboard/video-call-connect/" + messageData.videoData.videoId;
			// let fullUrl = constant.VIDEO_CALL_URL + url;
			// 
		data.history.push(url);	// clinetlive
			//  props.history.push("https://test.medfixhealth.com" + url);	// clineTestlive
			// window.open('http://52.34.207.5:5127' + url, title, 'toolbar=0,status=0,width=548,height=325'); //staging
			//
			// props.history.push("http://localhost:3000" + url);
			//  window.open('http://localhost:3000' + url, title, 'toolbar=0,status=0,width=548,height=325', "_blank");//local
			//sagar local
			// props.history.push("http://172.10.28.60:3000" + url);
			//ridhi local
			// props.history.push("http://172.10.28.60:3000" + url);
			// window.open('http://172.10.221.185:3000' + url, title, 'toolbar=0,status=0,width=548,height=325', "_blank");//local sagar
			// window.open('http://localhost:3000' + url);//local
			// props.history.push(url)
		});
		//done image
		socket.on("notify_disconnet_call", function (messageData) {
			console.log("notify_disconnet_call", messageData)
			// alert('called  notify_disconnet_call');
			// window.close();

			let routePath =
				messageData.userType == "patient"
					? "/specialist/my-appointment" : "/dashboard/my-appointment";

			let message =
				messageData.userType == "patient"
					? "Call disconneted from " + messageData.userType
					: "Call disconneted from " + messageData.userType;

		data.history.push(routePath);
			toast.info(message);
		});

		// 	let routePath =	(messageData.userType == "patient")? "/specialist/my-appointment" : '/specialist/appointment-consultation/';
		// 			// ? "/specialist/my-appointment" : "/verify-user";
		// 	let message =
		// 		messageData.userType == "patient"
		// 			? "Call disconneted from " + messageData.userType
		// 			: "Call disconneted from " + messageData.userType;

		// 	props.history.push(routePath);
		// 	toast.info(message);

		// });



		socket.on("notify_notrecieved_call", function (messageData) {
			this.setState({
				newId: localStorage.getItem('appointmentId')
			})
			let appointmentObj = {
				appointmentId: this.state.newId
			}
			this.props.actions.getAppointmentDetails(appointmentObj);
			let routePath =
				messageData.videoData.userType == "patient"
					? "/dashboard/my-appointment"
					: '/specialist/appointment-consultation/' + this.state.newId;
			let message =
				messageData.videoData.userType == "patient"
					? "Specialist may busy with another call. Please try after some time"
					: "Patient may busy with another call. Please try after some time";
		data.history.push(routePath);
			toast.info(message);
		});
	}
	componentDidMount() {
		var user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {};
		var userId = localStorage.getItem("userId");
		console.log("++_.", this)
		
		// debugger;
		if (!user && !userId) {
		this.props.history.push('/')
		} else {
			console.log("+++...useridfd", user, userId)
			socket.emit("adduser", { userId  });
			this.socketFunction(this.props)
		}
	}

	render() {
		// const { store, history } = this.props;

		// 
		return (
			<ScrollToTop>
				<Switch>
					<Route exact path="/" component={Index} />
					<Route exact path="/reset-password/:resetkey" component={Index} />
					<Route exact path="/activate-account/:activationKey" component={Index} />
					<Route exact path="/email-verification/:emailToken" component={Index} />
					<Route exact path="/unlock-account/:unlockKey" component={Index} />
					<Route exact path="/unsubscribe-emails/:key" component={Index} />
					<Route exact path="/gapi/auth" component={GapiIndex} />
					<Route exact path="/outlook/auth" component={OutlookIndex} />
					<Route path="/marketing" component={AsyncMarketingDashboard} />
					<Route exact path="/user" component={adminAuth} />
					<PatientPrivateRoute exact path="/dispute/:appointmentId/:disputeId/:subDisputeId" component={disputeAppointment} />
					<PatientPrivateRoute exact path="/dispute/:appointmentId/:disputeId" component={disputeAppointment} />
					<Route exact path="/disputes/login/:appointmentId" component={disputeLogin} />
					<PatientPrivateRoute exact path="/disputes/searchDisputelist" component={disputeList} />
					<PatientPrivateRoute exact path="/disputes/disputeSubmitted" component={disputeSearch} />
					<Route exact path="/disputes/:appointmentId" component={disputeHelp} />
					<PatientPrivateRoute path="/dashboard" component={Dashboard} />
					<SpecialistPrivateRoute path="/specialist" component={SpecialistDashboard} />
					<Route exact path="/specialist-requirements" component={SpecialistRequirements} />
					<AdminPrivateRoute path="/user" component={AdminIndex} />
					<Route path="*" component={ErrorPage} />
				</Switch>
			</ScrollToTop>
		);
	}
}

